import { autocompleteGhostText } from '../actions/internalActions';
import { addSuggestionPill, onSearchTextChanged } from '../actions/publicActions';
import datapoints from '../datapoints';
import getSuggestionAtIndex from '../selectors/getSuggestionAtIndex';
import isGhostTextVisible from '../selectors/isGhostTextVisible';
import { getStore } from '../store/store';
import { logUsage } from 'owa-analytics';
import { lazyLogSearchBoxStateChanged, SuggestionKind } from 'owa-search-service';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
/**
 * This will get run once a user attempts to complete the ghost text visible
 * to them. If a workload does not have suggestions (i.e. calendar as of 5/15),
 * the function will terminate early as the ghostText property in the store
 * will be an empty string.
 */
export default orchestrator(autocompleteGhostText, function (actionMessage) {
    // Bail if there's no visible ghost text.
    if (!isGhostTextVisible()) {
        return;
    }
    // Bail if cursor position isn't at end of search input.
    if (actionMessage.cursorPosition !== getStore().searchText.length) {
        return;
    }
    // Get suggestion that is being ghosted.
    var suggestion = getSuggestionAtIndex(0 /* index */);
    // Since getSuggestionAtIndex can return null, do a null check for safety.
    if (!suggestion) {
        return;
    }
    /**
     * Log 3S instrumentation event that search box text is changing because of
     * ghost text.
     */
    lazyLogSearchBoxStateChanged.importAndExecute(new Date() /* currentTime */, 'ghost' /* reason */, suggestion.ReferenceId, getStore().latestTraceId);
    /**
     * - If suggestion pill suggestion, add pill and clear searchTextForSuggestion.
     * - If keyword suggestion, set searchText and searchTextForSuggestion as
     *   the text of the suggestion.
     */
    switch (suggestion.kind) {
        case SuggestionKind.People: {
            addSuggestionPill(suggestion, true /* suggestionSelected */);
            break;
        }
        case SuggestionKind.Keywords: {
            onSearchTextChanged(getStore().ghostText);
            break;
        }
        default: {
            trace.error('Attempted to autocomplete ghost text for an unsupported suggestion kind.');
        }
    }
    // Log CTQ if autocomplete was triggered by TAB or right arrow.
    var _a = datapoints.SuggestionTextAutocompleted.datapoint, eventName = _a.name, customData = _a.customData;
    logUsage(eventName, customData(actionMessage.keyUsed));
});
//# sourceMappingURL=autocompleteGhostTextOrchestrator.js.map